import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { useNavigate } from 'react-router-dom'
import { usePhoto } from '@/hooks/index'
import useStudents from '@/hooks/useStudents'
import useContacts from '@/hooks/useContacts'
import useOnboarding from '@/hooks/useOnboarding'
import OnboardingWizard from '@/components/OnboardingWizard'
import Spinner from '@/components/Spinner'

export default function OnboardingPage() {
  const [isLoading, setIsLoading] = useState(true)
  const { isOnboarding, startOnboarding, completeOnboarding } = useOnboarding()
  const navigate = useNavigate()

  //pre-fetch data
  usePhoto()
  const { students, isLoading: isLoadingStudents } = useStudents()
  const { contacts, isLoading: isLoadingContacts } = useContacts()

  useEffect(() => {
    if (isLoadingStudents || isLoadingContacts) return
    if (!students || !contacts) return

    //only run if the parent has just logged in
    if (isOnboarding === undefined) {
      if (students?.length < 1 || contacts.length < 2) {
        Sentry.logger.debug(Sentry.logger.fmt`Onboarding - ${students?.length} students and ${contacts.length} contacts`)
        startOnboarding()

        setIsLoading(false)
      } else {
        Sentry.logger.debug('Not onboarding')
        completeOnboarding()
        setIsLoading(false)
        navigate(`../progress`)
      }
    } else {
      Sentry.logger.debug('Onboarding is already set')
      if (isOnboarding === false) {
        Sentry.logger.debug('Onboarding complete, navigating to progress')
        navigate(`../progress`)
      } else {
        setIsLoading(false)
        Sentry.logger.debug('Onboarding in progress, staying on onboarding page')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [students, contacts])

  if (isLoading) {
    return (
      <div className='flex flex-col items-center mx-auto py-56'>
        <div className='text-xl font-serif text-white mb-4 '> Signing in...</div>
        <Spinner />
      </div>
    )
  }

  return <OnboardingWizard />
}
